
    import './styles.scoped.css';
    export default {
  "button": "awsui_button_m5h9f_1tyxr_9",
  "expanded": "awsui_expanded_m5h9f_1tyxr_61",
  "offset-right-none": "awsui_offset-right-none_m5h9f_1tyxr_72",
  "offset-right-l": "awsui_offset-right-l_m5h9f_1tyxr_75",
  "offset-right-xxl": "awsui_offset-right-xxl_m5h9f_1tyxr_78",
  "text": "awsui_text_m5h9f_1tyxr_103",
  "icon": "awsui_icon_m5h9f_1tyxr_107"
};
  